
import { Component, namespace, Vue } from "nuxt-property-decorator";
import SummedRating from "~/components/molecules/display/ratings/SummedRating.vue";

import iconBarzahlung from "~/assets/images/pellets/barzahlung.svg";
import iconEcKarte from "~/assets/images/pellets/ec-karte.svg";
import iconLastschrift from "~/assets/images/pellets/lastschrift.svg";
import iconRechnung from "~/assets/images/pellets/rechnung.svg";

const EsyoilStore = namespace("esyoil");

interface PaymentMethod {
  id: string;
  name: string;
  icon: string;
}

@Component({
  components: {
    SummedRating,
  },
})
export default class PelletsTrustBadges extends Vue {
  @EsyoilStore.State("companyRating")
  companyRating: { ratingValue: number; ratingCount: number };

  paymentMethods: PaymentMethod[] = [
    {
      id: "ec",
      name: "EC Karte",
      icon: iconEcKarte,
    },
    {
      id: "cash",
      name: "Bar",
      icon: iconBarzahlung,
    },
    {
      id: "invoice",
      name: "Rechnung",
      icon: iconRechnung,
    },
    {
      id: "debit",
      name: "Lastschrift",
      icon: iconLastschrift,
    },
  ];
}
